
    /** Generated by webpack-jst-loader */
    (function() {
      window.JST || (window.JST = {});
      window.JST["app_people/components/user_stream/templates/list_segment"] = Handlebars.template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div class='column_character'>\n  <div class='column_label' role=\"cell\">\n    "
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"character") || (depth0 != null ? lookupProperty(depth0,"character") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"character","hash":{},"data":data,"loc":{"start":{"line":3,"column":4},"end":{"line":3,"column":17}}}) : helper)))
    + "\n  </div>\n</div>\n<div class='segment_content_wrapper'></div>\n";
},"useData":true});
    }).call(this);
  